// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6ff1c956","977":"1e811e24"}[chunkId] + ".chunk.js";
};